import React from "react";
import "./styles.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SEO from "../../components/SEO/SEO";
import { toLangPath } from "../../utilities/helpers";

export default function NotFound() {
  const { t } = useTranslation();
  const language = useSelector((state) => state.general.language);
  const lang = language === "en" ? "en" : "bg";

  const copy =
    lang === "en"
      ? { title: "Page not found", text: "The page you are looking for does not exist or has been moved.", home: "Back to homepage" }
      : { title: "Страницата не е намерена", text: "Страницата, която търсите, не съществува или е преместена.", home: "Към началната страница" };

  return (
    <>
      {/* Unknown URLs are served by the SPA fallback with a 200, so the noindex
          tag is what keeps them out of the index. */}
      <SEO title={`${copy.title} | Synergon Energy`} name={copy.title} description={copy.text} type={"website"} noindex />
      <div className="screen-wrapper not-found">
        <div className="screen-inner-wrapper">
          <h1>404 — {copy.title}</h1>
          <p>{copy.text}</p>
          <ul className="not-found-links">
            <li>
              <Link to={toLangPath("/", lang)}>{copy.home}</Link>
            </li>
            <li>
              <Link to={toLangPath("/products-and-services", lang)}>{t("general.headerProductsAndServices")}</Link>
            </li>
            <li>
              <Link to={toLangPath("/offers", lang)}>{t("general.getOffer")}</Link>
            </li>
            <li>
              <Link to={toLangPath("/contact", lang)}>{t("general.headerContact")}</Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
